import React, { Fragment, useEffect } from 'react';
import { translate } from '../Services/translation';
import { useSelector, useDispatch } from 'react-redux';
import { update as updateOrderRowQuantity } from '../Actions/Cart.action';
import { trackAddToCart } from '../Actions/HelloRetail.action';

const MiniCart = () => 
{
    const dispatch = useDispatch();
    const cart = useSelector((state) => state.cart);        
    let superBuilderParentOrderRows = (cart && cart.superBuilderParentOrderRows) || []; 
    let quantity = cart.quantity;   

    const configOrderRows = cart.orderRows.filter(function (row) {
        if (!row.comments) return true;
        var superBuilderBundleId = JSON.parse(row.comments).superBuilderBundleId;
        if (!superBuilderBundleId)
            return true;
    });

    let totalQuantity = configOrderRows.reduce(function (accumulator, item) {
        return accumulator + item.quantity;
    }, 0);
 
    
    useEffect(() => {
        if (sessionStorage.addedProducts && sessionStorage.addedProducts != quantity.toString()) { //avoid trigger on pageload            
            const script = document.querySelector(`script[src='https://helloretailcdn.com/helloretail.js']`);
            if (script) {
                trackAddToCart(cart);
            }
            sessionStorage.addedProducts = quantity;
        }

        if (sessionStorage.addedProducts === undefined || sessionStorage.addedProducts === null) {
            sessionStorage.addedProducts = "0";
        }
    }, [quantity]);
          

    quantity = superBuilderParentOrderRows.length + totalQuantity;
    {
        return <div className="cart-hover-trigger">
            <a href={cart.checkoutUrl} className="ti-menu-icon ti-menu-icon--cart ti-menu-icon--text">
                <span className="ti-menu-icon__title">{translate('minicart.checkout')}</span>
                <span className="cart-icon-container">
                    {quantity > 0 && <span className="cart-icon-container__indicator">
                        {quantity}
                    </span>}
                    <svg>
                        <use href="/ui/images/tibergs-svg/sprite/sprite.svg#cart"></use>
                    </svg>
                </span>
            </a>
            <div className={'mini-cart-content' + (cart.hintCart ? ' mini-cart-content--hint' : '')}>
                <div className="mini-cart-content__container">
                    {quantity > 0 ? <Fragment>
                        <div className="mini-cart-content__title-container">
                            <h3 className="mini-cart-content__title">{translate('minicart.header')}</h3>
                            <a className="ti-btn" href={cart.checkoutUrl}>{translate('minicart.tocheckout')}</a>
                        </div>
                        <div className="mini-cart-content__items-container">
                            <div className="mini-cart-content__items">
                                {renderMiniCart(superBuilderParentOrderRows.length, superBuilderParentOrderRows, cart.checkoutUrl, cart.hintCart, 
                                    cart.newlyAddedArticleNumber, true, dispatch)}
                                {renderMiniCart(configOrderRows.length, configOrderRows, cart.checkoutUrl, cart.hintCart, cart.newlyAddedArticleNumber, 
                                    false, dispatch)}
                            </div>
                        </div>
                    </Fragment> : <div className="mini-cart-content__empty">
                        {translate('minicart.empty')}
                    </div>}
                </div>
            </div>
        </div>
    }
}

const renderMiniCart = (quantity, orderRows, checkoutUrl, hintCart, newlyAddedArticleNumber, isSuperBuilder, dispatch) => {
    let itemRows = [];

    function removeMiniOrderRow(superBuilderItems) {        
          return superBuilderItems.map(v => v.articleNumber);         
      }

    return orderRows && orderRows.length > 0 ? <ul>
        {orderRows.map((row, index) => {
            let itemRows = isSuperBuilder ? row.parentItem : row;
            return <li className={`mini-cart-item ${itemRows.articleNumber === newlyAddedArticleNumber ? "hint-item" : ""}`} key={`orderrow-${index}`}>
                <div className="mini-cart-item__img-column">
                    <img alt={itemRows.articleNumber} src={itemRows.image}></img>
                </div>
                <div className="mini-cart-item__info-column">
                    <span className="mini-cart-item__name">{itemRows.name}</span>                    
                    <span className="cart-remove-row mini-cart-item__remove-row" onClick={() => 
                        dispatch(updateOrderRowQuantity(isSuperBuilder ? removeMiniOrderRow(row.subVariants) : [itemRows.articleNumber], 0))}>
                        <svg>
                            <use href="/ui/images/tibergs-svg/sprite/sprite.svg#close"></use>
                        </svg>
                    </span>
                    <div className="mini-cart-item__content">
                        <div className="mini-cart-info">
                            <span className="mini-cart-info__title">{translate('minicart.myselection')}</span>
                            <ul className="mini-cart-info__list">
                                <li><span>{translate('minicart.quantity')}:</span> {itemRows.quantity}</li>
                                {itemRows.options.map((option, index) => {
                                    return <li key={`option-${index}`}>
                                        {option.name !== '' &&
                                            <span>{option.name}:</span>} {option.value}
                                    </li>
                                })}
                            </ul>
                        </div>
                        <div className="mini-cart-item__price-column">
                            <div className="mini-cart-prices">
                                <span className="mini-cart-prices__current">{itemRows.totalPrice}</span>
                                {(isSuperBuilder ? (itemRows.totalPriceValue !== itemRows.priceValue) : (itemRows.totalPriceValue !== itemRows.totalOrdinaryPriceValue)) &&
                                    <span className="mini-cart-prices__ordinary">{isSuperBuilder ? itemRows.price : itemRows.totalOrdinaryPrice}</span>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        })}
    </ul> : <></>
}

export default MiniCart;